/**
 * tdesign v1.11.4
 * (c) 2025 tdesign
 * @license MIT
 */

import { getSSRAttach, getAttach } from '../utils/dom.mjs';
import { computed, ref, onMounted, watch } from 'vue';
import { isFunction } from 'lodash-es';
import '../_chunks/dep-b0ea6825.mjs';

var useTeleport = function useTeleport(attach, triggerNode) {
  var to = isFunction(attach) ? computed(attach) : ref(attach);
  var innerTriggerNode = isFunction(triggerNode) ? computed(triggerNode) : ref(triggerNode);
  var element = ref();
  var getElement = function getElement() {
    element.value = getSSRAttach() || getAttach(to.value, innerTriggerNode.value);
  };
  onMounted(function () {
    return getElement();
  });
  watch([to, innerTriggerNode], function () {
    return getElement();
  });
  return element;
};

export { useTeleport as default };
//# sourceMappingURL=useTeleport.mjs.map
